/* eslint-disable */  
const hub = process.env.HUB_URL;
const api_go = process.env.API_GO_URL;
const red = process.env.API_NODE;

export {hub, api_go, red};


// WEBPACK FOOTER //
// ./src/utils/config.js